import React from "react";
import { Card, CardContent } from "../../components/ui/card";
import { Eye, BarChart3, Lightbulb } from "lucide-react";

export default function ValuePropositionsSection() {
  return (
    <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-headline text-slate-900 mb-6">
            What You Get: <span className="text-blue-500">Unfiltered Insights</span> for Real Growth
          </h2>
          
          <p className="body-text text-slate-600 max-w-3xl mx-auto">
            Stop guessing about your communication patterns. Get concrete, data-driven insights that help you understand yourself and improve your relationships.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <Card className="border-slate-200 hover:shadow-xl transition-all duration-300 group">
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <Eye className="w-8 h-8 text-white" />
              </div>
              <h3 className="feature-title text-slate-900 mb-4">Understand How You Come Across</h3>
              <p className="body-text text-slate-600">
                Discover the gap between how you intend to communicate and how your messages are actually received by your partner.
              </p>
            </CardContent>
          </Card>
          
          <Card className="border-slate-200 hover:shadow-xl transition-all duration-300 group">
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <BarChart3 className="w-8 h-8 text-white" />
              </div>
              <h3 className="feature-title text-slate-900 mb-4">Identify Patterns & Triggers</h3>
              <p className="body-text text-slate-600">
                Uncover recurring themes in your conversations, emotional triggers, and communication patterns you might not have noticed.
              </p>
            </CardContent>
          </Card>
          
          <Card className="border-slate-200 hover:shadow-xl transition-all duration-300 group">
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <Lightbulb className="w-8 h-8 text-white" />
              </div>
              <h3 className="feature-title text-slate-900 mb-4">Personalized Growth Tips</h3>
              <p className="body-text text-slate-600">
                Get specific, actionable recommendations tailored to your unique communication style and relationship dynamics.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
} 